import { Tag, UserCreatedOption } from 'types/types';
import { MultipleChoiceAutoTag } from './types';
import { Container, IndividualOption, Select, Option } from './styles';

export interface MultipleChoiceVariantProps {
  fetchedTags: Tag[];
  handleMultipleChoiceSave: (tagId: number, option: UserCreatedOption) => void;
  multipleChoiceOptions: string[];
  selectedValues: MultipleChoiceAutoTag[];
}

const MultipleChoiceVariant: React.FC<MultipleChoiceVariantProps> = ({
  fetchedTags,
  handleMultipleChoiceSave,
  multipleChoiceOptions,
  selectedValues,
}) => {
  const handleChange = (event, option) => {
    const tagId = event.target.value;
    handleMultipleChoiceSave(tagId, option);
  };

  const getSelectedValueForOption = (option: string) => {
    const selectedTag = selectedValues.find((tag) => tag.option === option);
    return selectedTag ? selectedTag.tag_id.toString() : '';
  };

  return (
    <Container>
      {multipleChoiceOptions.map((option, index) => (
        <IndividualOption key={index}>
          If candidate responds {option}
          <Select
            onChange={(event) => handleChange(event, option)}
            value={getSelectedValueForOption(option)}
          >
            <Option value="">Select a tag</Option>
            {fetchedTags.map((fetchedTag) => {
              return (
                <Option value={fetchedTag.id} key={fetchedTag.id}>
                  {fetchedTag.label}
                </Option>
              );
            })}
          </Select>
        </IndividualOption>
      ))}
    </Container>
  );
};

export default MultipleChoiceVariant;
